<template>
  <div class="box">eventbox</div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
</style>